module.exports = __webpack_public_path__ + "img/1644218510942.34f6d7c3.jpeg";